import { render, staticRenderFns } from "./Form76.vue?vue&type=template&id=b8dba2e2&scoped=true&"
import script from "./Form76.vue?vue&type=script&lang=js&"
export * from "./Form76.vue?vue&type=script&lang=js&"
import style0 from "./Form76.vue?vue&type=style&index=0&id=b8dba2e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dba2e2",
  null
  
)

export default component.exports